import React from 'react';
import { graphql, useFragment } from 'react-relay';
import { ProjectIcon } from '@atlassian/jira-horizontal-nav-icons/src/ui/icon/index.tsx';
import type { ProjectAvatar$key } from '@atlassian/jira-relay/src/__generated__/ProjectAvatar.graphql';
import { NavigationKitAvatarPopup } from './navigation-kit-avatar-popup/NavigationKitAvatarPopup.tsx';

const ProjectAvatar = ({
	projectRef,
	withEditMode,
}: {
	projectRef: ProjectAvatar$key;
	withEditMode?: boolean;
}): React.JSX.Element | null => {
	const data = useFragment<ProjectAvatar$key>(
		graphql`
			fragment ProjectAvatar on JiraProject {
				projectType
				projectId
				avatar {
					large
				}
				canEditProjectConfig: action(type: EDIT_PROJECT_CONFIG) {
					canPerform
				}
			}
		`,
		projectRef,
	);
	if (data?.projectType === 'BUSINESS' || withEditMode) {
		return (
			<NavigationKitAvatarPopup
				canEdit={data?.canEditProjectConfig?.canPerform ?? false}
				projectId={Number(data?.projectId)}
				selectedAvatarUrl={data?.avatar?.large ?? ''}
			/>
		);
	}
	if (!data.avatar) {
		return null;
	}
	return (
		<ProjectIcon
			src={`${data.avatar.large}?size=xlarge`}
			alt=""
			// eslint-disable-next-line jira/integration/test-id-by-folder-structure
			data-testid="horizontal-nav.ui.content.project-avatar"
			data-vc="jira-horizontal-nav-project-icon"
		/>
	);
};

export default ProjectAvatar;
